import * as React from 'react'
import { useMutationMaintenanceMode } from '@/modules/shared/query-client/useMutationMaintenanceMode'

export const MaintenanceBanner: React.FC = () => {
  const mutation = useMutationMaintenanceMode()

  return (
    <div className="tw-sticky tw-top-0 tw-z-[9999] tw-flex tw-items-center tw-justify-center tw-gap-4 tw-bg-orange-500 tw-px-6 tw-py-2 tw-text-white tw-text-sm">
      <span className="tw-font-semibold">Tryb przerwy technicznej jest aktywny</span>
      <button
        onClick={() => mutation.mutate({ isActive: false, message: '' })}
        disabled={mutation.isPending}
        className="tw-rounded tw-border tw-border-white tw-px-3 tw-py-1 tw-text-white tw-text-xs tw-font-semibold tw-cursor-pointer hover:tw-bg-orange-600 disabled:tw-opacity-50"
      >
        {mutation.isPending ? 'Wyłączanie...' : 'Wyłącz'}
      </button>
    </div>
  )
}
